import { Helmet } from "react-helmet-async";
import { SITE_URL, SITE_NAME } from "../lib/seo";

// Per-page head tags; also rendered into static HTML at build time by scripts/prerender.mjs.
const SEO = ({
    title,
    description,
    path = "/",
    ogImage,
    type = "website",
    noindex = false,
}) => {
    const canonical = `${SITE_URL}${path}`;
    return (
        <Helmet>
            <html lang="da" />
            <title>{title}</title>
            <meta name="description" content={description} />
            {!noindex && <link rel="canonical" href={canonical} />}
            {noindex && <meta name="robots" content="noindex,follow" />}

            {/* Open Graph */}
            <meta property="og:site_name" content={SITE_NAME} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            {!noindex && <meta property="og:url" content={canonical} />}
            <meta property="og:type" content={type} />
            <meta property="og:locale" content="da_DK" />
            {ogImage && <meta property="og:image" content={ogImage} />}
            {ogImage && <meta property="og:image:alt" content={title} />}

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            {ogImage && <meta name="twitter:image" content={ogImage} />}
        </Helmet>
    );
};

export default SEO;
